import AppBar from "@mui/material/AppBar"
import Box from "@mui/material/Box"
import Toolbar from "@mui/material/Toolbar"
import logo from "@/common/images/843_Logo_Blue.png"
import NavLinks from "./NavLinks"

import { UserButton } from "../users/UserIcon"
import MapFilterNavigation from "../mapFilter/MapFilter"
import SearchBar from "./SearchBar"
import { useLocation } from "react-router-dom"
import { useNavBarContext } from "@/contexts/NavBarContext"
import useIsTablet from "@/hooks/useIsTablet"
import { useEventContext } from "@/contexts/EventContext"

export default function MuiDesktopNavBar() {
  const location = useLocation()
  const isTablet = useIsTablet()
  const { setIsHovered } = useNavBarContext()
  const { searchActive } = useEventContext()

  return (
    <AppBar
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      position="sticky"
      sx={{
        backgroundColor: "white",
        justifyContent: "center",
      }}
    >
      <Toolbar
        sx={{
          marginLeft: isTablet ? "" : "2rem",
          marginRight: isTablet ? "" : "2rem",
          position: "relative",
        }}
      >
        <a
          href="/about-us"
          style={{
            // display: "flex",
            // alignItems: "center",
            width: "50px",
            height: "50px", // or a fixed width if needed
          }}
        >
          <img
            src={logo}
            alt="843hub Logo"
            style={{
              width: "101px", // Set a specific width
              height: "59px", // Set a specific height
              // transform: "scale(1.2, 1.2)",
            }}
          />
        </a>
        {isTablet && <SearchBar />}
        {isTablet && searchActive ? <></> : <NavLinks />}
        {/* <NavLinks /> */}
        <Box sx={{ flexGrow: 1 }}></Box>
        {!isTablet && <SearchBar />}
        <UserButton />
      </Toolbar>
      {!["/profile", "/about-us"].includes(location.pathname) && (
        <MapFilterNavigation />
      )}
    </AppBar>
  )
}
